import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {useParams} from "react-router";
import {LoadingState} from "../../../../components/fouladyar/loading-state/loadingState";
import {EmptyStateObject, filterStructure, tableStatics, tableStructure} from "./index";
import Table from "../../../../components/fouladyar/table";
import {ErrorToaster} from "../../../../shared/toaster";


const AllRequestOfOrderStrategyCode = () => {

    const {t, i18n} = useTranslation();
    const {id} = useParams();
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const [data, setData] = useState([
        // {
        //     _id: '0292283293813203032',
        //     firstName: 'محسن',
        //     lastName: 'رضایی',
        //     broker: 'alpari',
        //     expirationDate: '۱۴۰۳/۰۱/۰۵',
        //     accountNumber: '99665211656'
        // },
        // {
        //     _id: '0292283293813203032',
        //     firstName: 'محسن',
        //     lastName: 'رضایی',
        //     broker: 'alpari',
        //     expirationDate: '۱۴۰۳/۰۱/۰۵',
        //     accountNumber: '99665211656'
        // },
        // {
        //     _id: '0292283293813203032',
        //     firstName: 'محسن',
        //     lastName: 'رضایی',
        //     broker: 'alpari',
        //     expirationDate: '۱۴۰۳/۰۱/۰۵',
        //     accountNumber: '99665211656'
        // },
        // {
        //     _id: '0292283293813203032',
        //     firstName: 'محسن',
        //     lastName: 'رضایی',
        //     broker: 'alpari',
        //     expirationDate: '۱۴۰۳/۰۱/۰۵',
        //     accountNumber: '99665211656'
        // },
        // {
        //     _id: '0292283293813203032',
        //     firstName: 'محسن',
        //     lastName: 'رضایی',
        //     broker: 'alpari',
        //     expirationDate: '۱۴۰۳/۰۱/۰۵',
        //     accountNumber: '99665211656'
        // },
    ]);

    const [isLoading, setIsLoading] = useState(false);
    const [selectedBotId, setSelectedBotId] = useState('');
    const [pagination, setPagination] = useState({
        itemPerPage: 7,
        currentPage: 1,
        totalItems: 0,
        lastUpdateBy: ''
    })


    const [filter, setFilter] = useState({})


    async function initializeData() {

        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/request-order-new-strategy-code/admin/list`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            console.log('data', res)

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setData(res.data.data.orders)
                setPagination({...pagination, totalItems: res.data.data.totalItems || 9, lastUpdateBy: 'initializer'})
                setIsLoading(false)
            }

        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    async function fetchData(updater) {
        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/request-order-new-strategy-code/admin/list/list?limit=${pagination.itemPerPage}&page=${pagination.currentPage}&${filter}`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200) {
                setData(res.data.data.orders)
                if (updater === 'filter')
                    setPagination({
                        ...pagination,
                        totalItems: res.data.data.totalItems,
                        currentPage: 1,
                        lastUpdateBy: updater
                    })
            }

            setIsLoading(false)
        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        initializeData();
    }, []);


    useEffect(() => {
        if (pagination.lastUpdateBy === "pagination")
            fetchData('pagination');

    }, [pagination]);


    useEffect(() => {
        // fetchData('filter');
    }, [filter]);



    const [loading, setLoading] = useState(false);


    function AllOrders() {
        return (
            <div className={"pt-4"}>
                <Table
                    loading={isLoading}
                    filter={filter}
                    tableData={data}
                    pagination={pagination}
                    tableHeading={tableStatics}
                    tableStructure={tableStructure}
                    filterStructure={filterStructure}
                    // tableActionsStructure={profile.roles.includes('admin') ? [] : TableActionsStructure}
                    emptystate={EmptyStateObject}
                    onItemPerPageChange={(itemPerPage, currentPage) => {
                        setPagination({
                            ...pagination,
                            itemPerPage: itemPerPage,
                            currentPage: currentPage,
                            lastUpdateBy: 'pagination'
                        })
                    }}
                    onCurrentPageChange={(currentPage) => {
                        setPagination({...pagination, currentPage: currentPage, lastUpdateBy: 'pagination'})
                    }}
                    onFilterSubmit={(e) => {
                        setFilter(e);
                    }}
                    onDeleteComplete={async (e) => {
                        await fetchData('filter');
                    }}
                />
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="grid">
                <div>
                    {
                        loading ?
                            <div className="pt-5 pb-5 d-flex justify-center align-center">
                                <LoadingState/>
                            </div> :
                            <AllOrders/>
                    }
                </div>
            </div>


        </React.Fragment>
    );
};

export default AllRequestOfOrderStrategyCode;

